import apiFetch from '../apiFetch'

export default function (token, organizedUnitId) {
  return apiFetch({ endPoint: `OrganizedUnit/${organizedUnitId}/DependentOrganizedUnits`, method: 'GET', body: null, token: token })
}
